import axios from "axios";


export function reviewDecisionAPI(action) {

    const metaData = {
      withCredentials: true,
    };

    const payload = {
        accepted: action.accepted,
        uniqueName: action.uniqueName,
        reason: action.reason
    };

    return new Promise((resolve) => {
        axios.post(`${process.env.REACT_APP_BACKEND}/review/decision`, payload, metaData)
            .then((response) => resolve(response.data))
            .catch((response) => resolve(response.status))
        });
}